module.exports = __webpack_public_path__ + "img/jzsgaq.afdc911c.png";